import Vendors from "./pages/Vendors";
import Reviews from "./pages/Reviews";
import SingleReview from "./pages/SingleReview";
import Header from "./components/Header/Header";
import LoginPage from "./pages/LoginPage";
import { Route, Routes } from "react-router-dom";
import RequireAuth from "./Auth/RequireAuth";
import PersistLogin from "./components/Login/PersistLogin";
import Layout from "./components/Layout/Layout";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          {/* Private Routes */}
          <Route element={<PersistLogin />}>
            <Route
              element={
                <RequireAuth
                  allowedRoles={process.env.REACT_APP_ALLOWED_ROLES.split(",")}
                />
              }
            >
              <Route
                path="/reviews"
                element={
                  <>
                    <Header />
                    <Reviews />
                  </>
                }
              />
              <Route
                path="/reviews/:id"
                element={
                  <>
                    <Header />
                    <SingleReview />
                  </>
                }
              />
              <Route
                path="/vendors"
                element={
                  <>
                    <Header />
                    <Vendors />
                  </>
                }
              />
              <Route
                path="/"
                element={
                  <>
                    <Header />
                    <Vendors />
                  </>
                }
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
